

//const BASE_URL = "http://localhost:8080";
const BASE_URL = "https://nodeserver.allamericancompanioncouncil.com";

export const API_URL = `${BASE_URL}/api/auth/`;
export const API_URL_TEST = `${BASE_URL}/api/test/`;
export const API_URL_IMAGE = BASE_URL;
export const CHAT_API_URL = `${BASE_URL}/api/chat/`;

/**
 * Auth storage mode for JWT token migration from localStorage to cookies.
 *
 * "dual"            — Write to both localStorage and cookie; read from
 *                     cookie first, fallback to localStorage. (default)
 * "cookie-only"     — Only use cookies (requires backend Set-Cookie).
 * "localstorage-only"— Legacy behavior, no cookie writes/reads.
 */
export const AUTH_MODE = "dual";
